import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../ui/accordion';

const faqs = [
  {
    question: 'Vad kostar fönstermålning?',
    answer: 'Priset beror på fönstrens antal, storlek och skick. Ett standardfönster kan kosta mellan 1 500 - 3 500 kr inklusive förarbete och målning. Vi ger alltid ett fast pris efter besiktning – inga dolda kostnader. Dessutom har du möjlighet att använda ROT-avdrag vilket sänker din kostnad betydligt.',
  },
  {
    question: 'Hur ofta behöver fönster målas?',
    answer: 'Generellt rekommenderas ommålning vart 8-15 år beroende på väderstreck, träslag och tidigare underhåll. Fönster som utsätts för mycket sol eller regn behöver underhållas oftare. Vi hjälper dig bedöma vid besiktningen.',
  },
  {
    question: 'Måste fönstren plockas ner?',
    answer: 'Inte nödvändigtvis. Många fönster kan målas på plats med gott resultat. Om fönstren är i sämre skick eller behöver mer omfattande renovering kan vi ta ner dem till vår verkstad. Vi diskuterar bästa lösning vid besiktningen.',
  },
  {
    question: 'När på året är bäst att måla fönster?',
    answer: 'Den bästa tiden för utvändig fönstermålning är april-oktober när temperaturen ligger över 10°C och luftfuktigheten är lagom. Invändig målning kan göras året runt. Vi planerar in jobbet när förutsättningarna är optimala.',
  },
  {
    question: 'Kan jag använda ROT-avdrag?',
    answer: 'Ja! Fönstermålning berättigar till ROT-avdrag som innebär att du får dra av 30% av arbetskostnaden (max 50 000 kr per person och år). Vi sköter all administration – du betalar bara den reducerade summan.',
  },
  {
    question: 'Hur lång tid tar det att måla fönster?',
    answer: 'Ett vanligt villahus med 10-15 fönster tar normalt 3-5 arbetsdagar beroende på skick och omfattning. Vi ger alltid en tidsuppskattning i offerten så du vet vad du kan förvänta dig.',
  },
  {
    question: 'Vilken färg använder ni?',
    answer: 'Vi använder högkvalitativa utomhusfärger från ledande tillverkare som Alcro och Beckers. Färgvalet anpassas efter fönstertyp och dina önskemål. Vi rekommenderar alltid färger med god UV-beständighet och elasticitet.',
  },
  {
    question: 'Vad ingår i priset?',
    answer: 'I vårt pris ingår alltid: skrapning av gammal färg, slipning, grundning, spackling vid behov, mellanstrykning, toppstrykning samt slutstädning. Vi specificerar allt i offerten så du vet exakt vad du betalar för.',
  },
];

export const FAQSection = () => {
  return (
    <section id="faq" className="section-padding bg-[#F1F5F9]" data-testid="faq-section">
      <div className="container-custom">
        <div className="grid lg:grid-cols-2 gap-16">
          {/* Left content */}
          <div className="lg:sticky lg:top-24 lg:self-start">
            <span className="text-[#C0392B] font-medium text-sm uppercase tracking-wider mb-4 block">
              Vanliga frågor
            </span>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-heading font-bold text-[#1F2937] mb-6">
              Har du frågor om fönstermålning?
            </h2>
            <p className="text-base md:text-lg text-[#64748B] mb-8">
              Här har vi samlat svar på de vanligaste frågorna vi får. Hittar du inte svar 
              på din fråga? Kontakta oss så hjälper vi dig.
            </p>
            <a
              href="tel:08-254604"
              className="inline-flex items-center gap-2 text-[#2C3E50] font-semibold hover:text-[#C0392B] transition-colors duration-200"
              data-testid="faq-phone-link"
            >
              <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
              </svg>
              Ring oss: 08-25 46 04
            </a>
          </div>

          {/* Right - FAQ accordion */}
          <div className="faq-accordion">
            <Accordion type="single" collapsible className="space-y-4">
              {faqs.map((faq, index) => (
                <AccordionItem
                  key={index}
                  value={`item-${index}`}
                  className="bg-white border border-[#E2E8F0] px-6 data-[state=open]:shadow-md transition-shadow duration-200"
                  data-testid={`faq-item-${index}`}
                >
                  <AccordionTrigger className="text-left py-5 hover:no-underline group">
                    <span className="text-[#1F2937] font-semibold pr-4 group-hover:text-[#C0392B] transition-colors duration-200">
                      {faq.question}
                    </span>
                  </AccordionTrigger>
                  <AccordionContent className="text-[#64748B] pb-5 leading-relaxed">
                    {faq.answer}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
